import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";  
import InsideHeader from "../../../components/InsideHeader";  
import { fetchNhifRate,   } from "../../../features/dropdown/dropdownSlice";


export default function NhifRatesTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { nhifRate, loading, nhifRateCount } = useSelector(
    (state) => state.dropdown
  );
  const { staffloading } = useSelector((state) => state.staff);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

 
    const filterDataList = searchText
    ? nhifRate?.filter((item) =>
        String(item?.fpPyear)?.toLowerCase().includes(searchText.toLowerCase()) || 
        String(item?.nrAmtmin)?.toLowerCase().includes(searchText.toLowerCase()) || 
        String(item?.nrAmtmax)?.toLowerCase().includes(searchText.toLowerCase()) || 
        String(item?.nrRate)?.toLowerCase().includes(searchText.toLowerCase())
      )
    : nhifRate;
   

  const [prodd, setProdd] = useState("");
  

  const handleEdit = () => {
    setopen(true);
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
  ];

  const columns = [
    {
      title: "Year",
      dataIndex: "fpPyear",
      sorter: (a, b) => a.fpPyear - b.fpPyear,
    },
    {
      title: "Minimum Amount",
      dataIndex: "nrAmtmin",
      sorter: (a, b) => a.nrAmtmin -b.nrAmtmin,
    }, 
    {
      title: "Maximum Amount",
      dataIndex: "nrAmtmax",
      sorter: (a, b) => a.nrAmtmax - b.nrAmtmax,

    },
    {
      title: "Rate",
      dataIndex: "nrRate",
      sorter: (a, b) => a.nrRate -b.nrRate,
    }, 
 
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchNhifRateData(page, size) {
   const res = await dispatch(
    fetchNhifRate({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
    console.log("es?.payload?.messages?.message",res?.payload)
    if(res?.payload?.messages?.message === "PERMISSION DENIED::YOU DON'T HAVE RIGHTS TO EDIT GLOBAL ITEMS"){
      navigate("/roles-error-page");
      return;
    }
  }

  useEffect(() => {
    fetchNhifRateData();
  }, []);

   

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Nhif Rate Information"
        subtitle="Manage Nhif rates within your institution"
        back={false}
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
           Nhif Rate Details
          </h3>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="flex items-center w-full ">
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search Nhif rate "
                className="text-[16px] font-[400] flex-row-reverse search-input"
                prefix={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.2508 3.75C7.50609 3.75 4.47041 6.93997 4.47041 10.875C4.47041 14.81 7.50609 18 11.2508 18C14.9955 18 18.0312 14.81 18.0312 10.875C18.0312 6.93997 14.9955 3.75 11.2508 3.75ZM3.04297 10.875C3.04297 6.11154 6.71773 2.25 11.2508 2.25C15.7838 2.25 19.4586 6.11154 19.4586 10.875C19.4586 15.6385 15.7838 19.5 11.2508 19.5C6.71773 19.5 3.04297 15.6385 3.04297 10.875Z"
                      fill="#333333"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.045 15.913C16.3237 15.6201 16.7756 15.6201 17.0543 15.913L21.3902 20.4693C21.6689 20.7622 21.6689 21.237 21.3902 21.5299C21.1115 21.8228 20.6596 21.8228 20.3809 21.5299L16.045 16.9737C15.7663 16.6808 15.7663 16.2059 16.045 15.913Z"
                      fill="#333333"
                    />
                  </svg>
                }
              />
            </div>
            
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.nrId}
                columns={columns}
                dataSource={filterDataList}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: nhifRateCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchNhifRateData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      
     
    </div>
  );
}
